import { useEffect, useState } from "react";
import VideoUpload from "./VideoUpload";
import ThumbnailSelector from "./ThumbnailSelector";
import { toast } from "react-toastify";
import {
  createPreSignedUrl,
  createPreSignedUrlForVideo,
  getLocalStorage,
  setLocalStorage,
} from "../../../../helpers/v2/common";
import { getS3FolderName } from "../../../../services/commonServices";
import {
  uploadMapImageToS3,
  uploadVideoToS3,
} from "../../../../helpers/S3/uploadToS3";
import ProgressBar from "../../v2/ProgressBar";
import { WANT_AD_KEY, WANT_AD_KEY_TEMP } from "../../../../constants/common";
// Your existing dataURLToBlob function
const dataURLToBlob = (dataURI, type) => {
  const byteString = atob(dataURI.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type });
};

function convertVideoToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // When file reading is complete
    reader.onload = () => {
      resolve(reader.result);
    };

    // When an error occurs during reading
    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    // Read the file as a data URL
    reader.readAsDataURL(file);
  });
}

const WantAdVideoUpload = (props) => {
  const {
    completedPercentage,
    adType,
    handleFormValues,
    formValues,
    setUIKey,
    setCompletedPercentage,
    onStepComplete,
    isAgent,
    isEdit,
    onUpload,
    url,
    isFromBuyerListingService,
  } = props;
  const [videoUrl, setVideoUrl] = useState(formValues?.videoUrl);
  const [thumbnailUrl, setThumbnailUrl] = useState(formValues?.thumbnailImgUrl);
  const [videoUploadProgress, setVideoUploadProgress] = useState(0);
  const [uploadStep, setUploadStep] = useState(
    formValues?.thumbnailUrl ? "thumbnail" : "upload",
  );
  useEffect(() => {
    setVideoUrl(formValues?.videoUrl);
  }, [formValues?.videoUrl]);

  const handleVideoUpload = async (file) => {
    try {
      const response = await getS3FolderName({ isWantAd: true });
      if (response.errorCode !== 0) {
        toast.error("Something went wrong");
        return;
      }

      const folderName = response?.result?.folderName;
      const preSignedUrl = await createPreSignedUrlForVideo(true, folderName);

      // Call uploadVideoToS3 with a progress callback
      const videoUrl = await uploadVideoToS3(preSignedUrl, file, (progress) => {
        setVideoUploadProgress(progress);
      });

      setVideoUrl(videoUrl);
      toast.success("Video uploaded successfully!");
      setUploadStep("thumbnail");
    } catch (error) {
      console.error("Error uploading video:", error);
      toast.error("Error uploading video!");
    }
  };

  const base64ToBlob = (base64, contentType = "application/octet-stream") => {
    const byteCharacters = atob(base64.split(",")[1]); // Decode base64
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i += 512) {
      const slice = byteCharacters.slice(i, i + 512);
      const byteNumbers = new Array(slice.length);

      for (let j = 0; j < slice.length; j++) {
        byteNumbers[j] = slice.charCodeAt(j);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const handleThumbnailSelect = async (thumbnailBlob) => {
    try {
      const contentType = thumbnailBlob.startsWith("data:image/jpeg")
        ? "image/jpeg"
        : "application/octet-stream";
      const fileBlob = base64ToBlob(thumbnailBlob, contentType);

      const response = await getS3FolderName({ isWantAd: true });
      if (response.errorCode !== 0) {
        toast.error("Failed to get unique folder name");
        return;
      }

      const folderName = response?.result?.folderName;
      const preSignedUrl = await createPreSignedUrl(true, folderName);

      const s3ThumbnailUrl = await uploadMapImageToS3(
        preSignedUrl?.result?.[0]?.presignedUrl,
        fileBlob,
      );
      const thumbnailUrl = s3ThumbnailUrl.split("?")[0];
      setThumbnailUrl(thumbnailUrl);
      toast.success("Thumbnail uploaded successfully!");
    } catch (error) {
      console.error("Error uploading thumbnail:", error);
      toast.error("Error uploading thumbnail!");
    }
  };

  return (
    <>
      <ProgressBar
        unsaveKey={"clearVideo"}
        completedPercentage={completedPercentage}
        setUIKey={setUIKey}
        isEdit={isEdit}
        isFromBuyerListingService={isFromBuyerListingService}
      />
      <div className="location-header-wrap">
        <div className="layout-content-btm-sec position-static top-three-comp-shadow">
          <h2>Add a Video</h2>
        </div>
      </div>
      <div className="min-h-screen bg-background py-12">
        {uploadStep === "upload" ? (
          <VideoUpload
            onUpload={handleVideoUpload}
            url={videoUrl}
            videoUploadProgress={videoUploadProgress}
          />
        ) : (
          <div className="max-w-2xl mx-auto p-4">
            <ThumbnailSelector
              videoUrl={videoUrl}
              onSelect={handleThumbnailSelect}
            />
          </div>
        )}
      </div>
      <div className="inner-layout-footer-new">
        <div className="inner-btm-fixed-nav">
          <div className="btn-wrap text-center pb-40 pt-0">
            <button
              type="button"
              className="btn btn-primary w-100 mb-0"
              disabled={!videoUrl || !thumbnailUrl}
              onClick={() => {
                handleFormValues({
                  thumbnailImgUrl: thumbnailUrl,
                  videoUrl: videoUrl,
                });
                if (isAgent) {
                  if (completedPercentage > 50) {
                    setCompletedPercentage(completedPercentage);
                  } else {
                    setCompletedPercentage(55);
                  }
                } else {
                  onStepComplete();
                }
                setTimeout(() => {
                  setLocalStorage(
                    WANT_AD_KEY,
                    getLocalStorage(WANT_AD_KEY_TEMP),
                  );
                  setUIKey(null);
                }, 500);
              }}
            >
              {isEdit ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default WantAdVideoUpload;
